import { capitalize } from "lodash";
import { DateTime } from "luxon";

const normalizePaymentStatusLabel = (status: string): string => {
  return status
    .split("_")
    .map((e) => capitalize(e))
    .join(" ");
};

const formatDate = (
  dateString: string,
  timezone: string,
  format = DateTime.DATE_MED,
) => {
  if (!dateString) return "-";
  return DateTime.fromISO(dateString).setZone(timezone).toLocaleString(format);
};

const formatTransactionDate = (
  isoString?: string | null,
  dateFormat = DateTime.DATE_MED,
  timeFormat = DateTime.TIME_SIMPLE,
  timezone?: string,
) => {
  if (!isoString) return { date: undefined, time: undefined };
  const dt = DateTime.fromISO(isoString).setZone(timezone);

  return {
    date: dt.toLocaleString(dateFormat),
    time: dt.toLocaleString(timeFormat),
  };
};

export { formatDate, formatTransactionDate, normalizePaymentStatusLabel };
